import MemberRequest from "../../../../app/Controllers/MemberRequest";

/**
 *
 * @param data
 * @param req
 * @returns {boolean}
 */
function getResult(data,req) {
  let res=false;
  if (data.hasOwnProperty( req.params.name)) {
    let resTable=data[ req.params.name];
    if (resTable.hasOwnProperty("result")) {
      if (resTable["result"] === "yes") {
        res=resTable;
      }
    }
  }
  return res;
}


const sendDataTableApi = async function (name,queryFields,queryArgs,pageAlerts,objTable,filters) {
  let res=false;
  let req=new MemberRequest();
  req.params.name=name;
  req._pageAlerts=pageAlerts;
  filters=filters.replace(/"/g,"\\\"");
  if( queryArgs === undefined || queryArgs === null) queryArgs="";
  req.query=`{${name}(${queryArgs}start:"${objTable.start}",length:"${objTable.length}",order_column:"${objTable.order_column}",order_dir:"${objTable.order_dir}",filters:"${filters}"){result, recordsTotal, recordsFiltered,data{${queryFields}} } }`;
  res = await req.send(getResult);
  return res;
};

export default async function DataTableApi(name,queryFields,queryArgs,pageAlerts,objTable={start:0, length:10, order_column:0,
  order_dir:1,current_page:1 },filters="") {
  return await sendDataTableApi(name,queryFields,queryArgs,pageAlerts,objTable,filters);
}
